import classNames from 'classnames';
import { ChangeEvent, ReactNode, useEffect, useRef } from 'react';

import styles from '../../styles/fields/checkbox-field.module.css';

interface CheckboxFieldProps {
    name?: string | null;
    label?: ReactNode | null;
    value?: boolean | null;
    errors?: string[] | null;
    className?: string | null;
    onChange?: ((checked: boolean) => void) | null;
}

function CheckboxField({
    name = null,
    label = null,
    value = null,
    errors = null,
    onChange = null,
    className = null,
}: CheckboxFieldProps) {
    const internalRef = useRef<HTMLInputElement>(null);
    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        internalRef.current.setCustomValidity('');
        if (onChange !== null) {
            onChange(e.currentTarget.checked);
        }
    };
    useEffect(() => {
        internalRef.current.setCustomValidity(
            errors !== null && errors.length > 0 ? errors[0] : '',
        );
        if (errors !== null && errors.length > 0) {
            internalRef.current.reportValidity();
        }
    }, [errors]);
    return (
        <label htmlFor={name} className={classNames([styles.container, className])}>
            <input
                ref={internalRef}
                type="checkbox"
                name={name}
                id={name}
                checked={value || false}
                onChange={onInputChange}
                className={styles.input}
            />
            <span className={styles.label}>{label}</span>
        </label>
    );
}

export default CheckboxField;
